import simpleSoilAttribute from './simpleSoilAttribute';

export const FARMLAND_CLASSIFICATION = simpleSoilAttribute({
  key: 'Farmland Classification',
  ruleId: '288',
  shortFormData: {
    AggregationMethod: 'No Aggregation Necessary',
    TiebreakRule: '-1',
  },
});
